define([
	'internal_util/Util'
], function (
	Util
) {
	'use strict';

	/**
	 * WorkerPool class
	 */
	return new function () {
		var MyWorker = require("worker-loader?name=main-worker.[hash].js!./../main-worker");
		var _workerUrl = 'js/skids-worker.js#grunt-cache-bust',
			_minWorkers = 2,
			_workers = new Array(),
			_initialization = false,
			_cancel = new Array();


		// private methods

		function getIdleWorker() {
			for (var i = 0; i < _workers.length; i++) {
				if (_workers[i]['busy'] === false) {
					return _workers[i];
				}
			}

			return null;
		}

		function init(callbacks) {
			var workers = _minWorkers,
				i;

			if (_initialization) {
				return;
			}

			_initialization = true;

			if (navigator.hardwareConcurrency) {
				workers = navigator.hardwareConcurrency;
			}

			for (i = 0; i < workers; i++) {
				var worker = {
						id : i,
						busy : true,
						instance : new MyWorker(),//Worker(_workerUrl),
						callback : null
					};

				worker['instance'].addEventListener('message', (function (worker) {
					return function initListener() {
						worker['busy'] = false;

						worker['instance'].removeEventListener('message', initListener);

						for (i = 0; i < _workers.length; i++) {
							if (_workers[i]['busy']) {
								return;
							}
						}

						_initialization = false;

						Util.callCallbacks(callbacks);
					}
				})(worker));

				_workers.push(worker);
			}
		}

		function startRun(worker, name, data, callbacks) {
			var message = {
					name : name,
					data : data
				};

			worker['callback'] = callbacks;
			worker['busy'] = true;

			if (_cancel.indexOf(name) !== -1) {
				_cancel.splice(_cancel.indexOf(name), 1);
			}

			worker['instance'].addEventListener('message', function responseListener(message) {
				var name = message.data.name,
					data = message.data.data;

				worker['busy'] = false;
				worker['instance'].removeEventListener('message', responseListener);

				if (_cancel.indexOf(name) === -1) {
					Util.callCallbacks(worker['callback'], data);
				}
			});

			try {
				if (data instanceof ImageData) {
					worker['instance'].postMessage(message, [ data.data.buffer ]);
				} else {
					worker['instance'].postMessage(message);
				}
			} catch (error) {
				// TODO: implement error handling
			}
		}


		// public methods

		this.init = function (callbacks) {
			init(callbacks);
		};

		this.busy = function () {
			if (_workers.length !== 0) {
				return (getIdleWorker() === null);
			}

			return false;
		};

		this.run = function (name, data, callbacks) {
			var worker = getIdleWorker();

			if (_workers.length === 0 || _initialization) {
				if (_workers.length === 0 && !_initialization) {
					init(function () {
						var worker = getIdleWorker();

						if (worker !== null) {
							startRun(worker, name, data, callbacks);
						} else {
							// TODO: send busy error
							Util.callCallbacks(callbacks, null);
						}
					});
				}

				return;
			}

			if (worker !== null) {
				startRun(worker, name, data, callbacks);
			} else {
				// TODO: send busy error
				Util.callCallbacks(callbacks, null);
			}
		};

		this.cancel = function (name) {
			if (Util.isValidString(name) && _cancel.indexOf(name) === -1) {
				_cancel.push(name);
			}
		};

		this.shutdown = function () {
			for (var i = 0; i < _workers.length; i++) {
				if (_workers[i]['instance']) {
					_workers[i]['instance'].terminate();
				}
			}

			_workers = new Array();
		};
	}

});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/WorkerPool.js
// module id = 139
// module chunks = 4